<div class="privacy-container">
    <h1>Privacy Policy</h1>
    
    <p>Last updated: January 31, 2026</p>
  
    <h2>Information Collection and Use</h2>
    <p>
      We collect and store your <strong>email address</strong> and <strong>profile name</strong> 
      solely for the purpose of validating your identity and facilitating your access to our services.
    </p>
    
    <p>
      We do not share your personal information with third parties except as required by law 
      or to provide you with the services you request.
    </p>
</div>
